import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const FrontEndNonAuthMiddleware = ({ children, allowedRoles }) => {
    const location = useLocation();
    const authUser = localStorage.getItem("authClient");

    if (!authUser) {
        return <>{children}</>;
    }
    return <Navigate to="/not-found" state={{ from: location }} />;
};

export default FrontEndNonAuthMiddleware;
